import { useRef, TouchEvent } from 'react';

interface UseSwipeProps {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  onScroll?: (distance: number) => void;
  minSwipeDistance?: number;
  isDisabled?: boolean;
}

export const useSwipe = ({
  onSwipeLeft,
  onSwipeRight,
  onScroll,
  minSwipeDistance = 50,
  isDisabled = false,
}: UseSwipeProps) => {
  const touchStartX = useRef<number | null>(null);

  const onTouchStart = (e: TouchEvent) => {
    if (isDisabled) return;
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const onTouchMove = (e: TouchEvent) => {
    if (isDisabled || touchStartX.current === null) return;

    const currentX = e.changedTouches[0].clientX;
    const distance = touchStartX.current - currentX;

    if (onScroll) {
      onScroll(distance);
    }
  };

  const onTouchEnd = (e: TouchEvent) => {
    if (isDisabled || touchStartX.current === null) return;
    
    const touchEndX = e.changedTouches[0].clientX;
    const distance = touchStartX.current - touchEndX;

    if (Math.abs(distance) > minSwipeDistance) {
      if (distance > 0 && onSwipeLeft) {
        onSwipeLeft();
      } else if (distance < 0 && onSwipeRight) {
        onSwipeRight();
      }
    }

    // Reset the starting point when scroll end
    touchStartX.current = null;
    if (onScroll) onScroll(0);
  };

  return { onTouchStart, onTouchMove, onTouchEnd };
};
